/**
 * Optimized Tuition Teacher Management with Pagination and Caching
 */

import TuitionTeacherManagement from './TuitionTeacherManagement';
import withOptimization from '../../hoc/withOptimization';

export default withOptimization(TuitionTeacherManagement, {
  collection: 'tuitionTeachers',
  pageSize: 30,
  orderByField: 'createdAt',
  orderDirection: 'desc',
  cacheTTL: 5 * 60 * 1000
});

/**
 * Performance Improvements:
 * - Before: Loads ALL tuition teachers (500+) = 8-12s load time
 * - After: Loads 30 teachers at a time = 2-3s load time
 * - Firestore reads: 500+ → 30-150
 */
